import React, { Component } from "react";

class Courses extends Component {
  state = {};

  getRatingClass = (star, rating) => {
    let className = "fa fa-star";

    if (rating == null) return className;

    if (star <= Math.round(rating)) {
      className += " voted";
    }

    return className;
  };

  render() {
    const { courses } = this.props;

    if (!courses) return null;

    return (
      <div className="row post-type-archive-sfwd-courses">
        {courses.map(item => (
          <article
            id={"post-" + item.link}
            key={"post-" + item.link}
            className="col-md-4 col-sm-6 post-9 sfwd-courses type-sfwd-courses status-publish has-post-thumbnail hentry ld_course_category-finance"
          >
            <div className="post-container">
              <a className="post-thumbnail" href={item.link} aria-hidden="true">
                <img
                  src={item.thumbnail}
                  width="1024"
                  height="683"
                  className="attachment-large wp-post-image"
                />
              </a>
              <header className="entry-header">
                <h2 className="entry-title">
                  <a href={item.link} rel="bookmark">
                    {item.title}
                  </a>
                </h2>{" "}
              </header>
              <div className="course-grid-price" dangerouslySetInnerHTML={{ __html: item.price }} />
              <div className="entry-content">
                <div
                  className="wrap-rating header qtip-rating"
                  data-hasqtip="0"
                >
                  <div className="rating">
                    <span
                      className={this.getRatingClass(1, item.rating.average)}
                      data-vote="1"
                    />
                    <span
                      className={this.getRatingClass(2, item.rating.average)}
                      data-vote="1"
                    />
                    <span
                      className={this.getRatingClass(3, item.rating.average)}
                      data-vote="1"
                    />
                    <span
                      className={this.getRatingClass(4, item.rating.average)}
                      data-vote="1"
                    />
                    <span
                      className={this.getRatingClass(5, item.rating.average)}
                      data-vote="1"
                    />
                  </div>
                  <input type="hidden" name="rate" id="rate" value="5" />
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    );
  }
}

export default Courses;
